export const buildRegionizeRoute = (path) => `/${path}`;
